import { SpecialityAttributeKeys as _SpecialityAttributeKeys } from "@/types/educators/speciality"
import {
  EducatorsListingProfileItem,
  EducatorsSpecialitiesSpecialityIndex,
} from "@/types/serializers"
import { DataDrivenSpecialityFormData } from "./data-driven-form"
import { SpecialityFormData } from "./validation-schema"
import { useProps } from "@/lib/page-rendering"

export type IndexProps = {
  specialities: Array<{
    listing_profile: EducatorsListingProfileItem
    collection: Array<EducatorsSpecialitiesSpecialityIndex>
  }>
}

type SpecialityAttributeKeys =
  | _SpecialityAttributeKeys
  | "learning_style_description"

export const useIndexProps = () => useProps<IndexProps>()

export type FormProps = {
  speciality: SpecialityFormData
  selected: SpecialityAttributeKeys[]
}

export type NewProps = FormProps & {
  personal_listing_profile_id: string
  team_profile_options: Array<SelectOption>
}

export type EditProps = FormProps

export type DataDrivenNewProps = {
  speciality: DataDrivenSpecialityFormData
  personal_listing_profile_id: string
}

export type DataDrivenEditProps = {
  speciality: DataDrivenSpecialityFormData
}

export const useNewProps = () => useProps<NewProps>()

export const useEditProps = () => useProps<EditProps>()

export const useDataDrivenNewProps = () => useProps<DataDrivenNewProps>()

export const useDataDrivenEditProps = () => useProps<DataDrivenEditProps>()

export const useFormProps = () => useProps<FormProps>()
